module.exports = __webpack_public_path__ + "static/media/dropup-blue.b96d70e1.svg";